module.exports = __webpack_public_path__ + "img/house5.png";